import {Box, Collapse, Divider, Grid, Hidden, IconButton} from '@mui/material'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {ApprovalStatus, BusinessUnit, DateFrom, DateTo, Emergency, Status,} from '../../../components/SelectBox'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import PaginationSystem from '../../../components/Pagination/PaginationSystem'
import Drafts from './bidsComparisonComponent/Drafts'
import AllComparison from './bidsComparisonComponent/AllComparison'
import Held from './bidsComparisonComponent/Held'
import Rejected from './bidsComparisonComponent/Rejected'
import MyCharts from './bidsComparisonComponent/MyCharts'
import NotReleased from './bidsComparisonComponent/NotReleased'
import Typography from "@mui/material/Typography";
import {Controller, useForm} from "react-hook-form";
import moment from 'moment'
import {bidComparsionApprovalStatuses, bidComparsionStatuses} from "../../../constDatas/constDatas";
import {useGetCurrentUserInfoQuery} from "../../../store/api/userApi";
import WFA from "./bidsComparisonComponent/WFA";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import {useDispatch, useSelector} from "react-redux";
import {
    updateBCCFilterData,
    updatebidComparsionTab,
    updateSelectedGridData,
    updateSelectedSequence
} from "../../../store/slice/bidComparsionChart";
import LogDialog from "../../../components/Dialog/LogDialog";
import UploadDialog from "../../../components/Dialog/UploadDialog";
import {useGetComparisonAttachmentsQuery} from "../../../store/api/bidComparsion";
import {toggleUploadDialog} from "../../../store/slice/dialogSlice";

const BIDsComparison = () => {
    const [open, setOpen] = useState(true)
    const {data: userData} = useGetCurrentUserInfoQuery();
    const LOCALSTORAGE_BID_COMPARSION_TAB = 'bidComparsionTabValue'
    const bccFilterData = useSelector((state) => state.bidComparsionSlice.bccFilterData)
    const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)
    const defaultValues = {
        businessUnitId: bccFilterData.businessUnitId || '',
        emergency: bccFilterData.emergency || [-1],
        itemCode: bccFilterData.itemCode || [],
        dateFrom: bccFilterData.dateFrom || moment(new Date()).subtract(12, 'months').format('YYYY-MM-DD'),
        dateTo: bccFilterData.dateTo || moment(new Date()).format('YYYY-MM-DD'),
        approvalStatus: bccFilterData.approvalStatus || [-1],
        status: bccFilterData.status || [-1],
        orderStatus: bccFilterData.orderStatus || [-1]
    }

    const {watch, control, reset, setValue} = useForm({defaultValues})
    const [sourceId, setSourceId] = useState(null)
    const [, setAttachments] = useState([])
    const {data: attachmentsData, error, refetch: refetchAttachments} = useGetComparisonAttachmentsQuery(sourceId)

    const dispatch = useDispatch()

    const handleClick = () => {
        setOpen(!open)
    }

    const [tabValue, setTabValue] = useState(localStorage.getItem(LOCALSTORAGE_BID_COMPARSION_TAB) || '1')
    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)

    const handleChange = (event, newValue) => {
        setTabValue(newValue)
        dispatch(updateSelectedGridData([]))
        dispatch(updatebidComparsionTab(newValue))
        localStorage.setItem(LOCALSTORAGE_BID_COMPARSION_TAB, newValue)
    }

    const handleUpdateData = data => {
        dispatch(updateSelectedGridData(data))
        if (tabValue == '1') {
            dispatch(updateSelectedSequence(data?.[0].sequence))
        }
    }

    let xlGrid1, xlGrid2, lgGrid1, lgGrid2, mdGrid1, mdGrid2, smGrid1, smGrid2, xsGrid1, xsGrid2
    let xlColumn, lgColumn, mdColumn, smColumn, xsColumn

    //Grid
    xlGrid1 = open ? 8 : 11.4
    xlGrid2 = open ? 4 : 0.5

    lgGrid1 = open ? 8 : 11
    lgGrid2 = open ? 4 : 1

    mdGrid1 = open ? 12 : 12
    mdGrid2 = open ? 12 : 12

    smGrid1 = open ? 12 : 12
    smGrid2 = open ? 12 : 12

    xsGrid1 = open ? 12 : 12
    xsGrid2 = open ? 12 : 12

    //Column
    xlColumn = open ? 2.7 : 2
    lgColumn = open ? 3.1 : 2.5
    mdColumn = 3
    smColumn = 5
    xsColumn = 12

    const handleRowAttachment = (id) => {
        setSourceId(id)
        dispatch(toggleUploadDialog())
    }

    useEffect(() => {
        dispatch(updateBCCFilterData({}))

        reset({
            ...defaultValues,
            businessUnitId: bccFilterData.businessUnitId || userData?.data?.defaultBusinessUnitId
        })
        dispatch(updateSelectedGridData([]))
    }, [refreshClicked]);

    useEffect(() => {
        if (userData?.data) {
            setValue('businessUnitId', bccFilterData.businessUnitId || userData?.data?.defaultBusinessUnitId)
        }
    }, [userData]);

    useEffect(() => {
        refetchAttachments()
    }, [sourceId])

    useEffect(() => {
        if (localStorage.getItem(LOCALSTORAGE_BID_COMPARSION_TAB)) {
            dispatch(updatebidComparsionTab(localStorage.getItem(LOCALSTORAGE_BID_COMPARSION_TAB)))
        }
        dispatch(updateSelectedGridData([]))
        dispatch(updateSelectedSequence(null))
    }, []);

    const saveFilter = (value, key) => {
        setValue(key, value)
        dispatch(updateBCCFilterData({
            ...bccFilterData,
            [key]: value
        }))
    }

    return (
        <>
            <LogDialog/>
            <UploadDialog module={'BidComparison'} initialData={attachmentsData?.data} value={attachmentsData?.data}
                          setValue={setAttachments} onlyView={true}/>
            <Grid container spacing={3}>
                <Grid container spacing={3} mt={1} pl={3}>
                    <Grid item xs={12} sx={{display: 'flex', textAlign: 'center', alignItems: 'center', gap: 2}}>
                        <Typography sx={{fontWeight: 'bold'}} variant="h5" component="div">
                            Filters
                        </Typography>
                        <Divider textAlign="left" sx={{width: '95%'}}/>
                    </Grid>
                </Grid>

                <Grid item xs={xsGrid1} sm={smGrid1} md={mdGrid1} lg={lgGrid1} xl={xlGrid1}>
                    <Grid container display="flex" gap={2}>
                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <Controller render={({field: {value, onChange}}) => (
                                    <BusinessUnit value={value} setValue={e => {
                                        saveFilter(e, 'businessUnitId')
                                    }}/>
                                )} name="businessUnitId" control={control}/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <Controller render={({field: {value, onChange}}) => (
                                    <Emergency setValue={e => {
                                        saveFilter(e, 'emergency')
                                    }} value={value} hasAll/>
                                )} name="emergency" control={control}/>
                            </Box>
                        </Grid>
                        <Grid item xs={xsColumn} sm={smColumn} md={2} lg={2} xl={2}>
                            <Box sx={{pb: 2}}>
                                <Controller render={({field: {value, onChange}}) => (
                                    <DateFrom dateFrom={value} setDateFrom={e => {
                                        saveFilter(e, 'dateFrom')
                                    }}/>
                                )} name="dateFrom" control={control}/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <Controller render={({field: {value, onChange}}) => (
                                    <DateTo dateTo={value} setDateTo={e => {
                                        saveFilter(e, 'dateTo')
                                    }}/>
                                )} name="dateTo" control={control}/>
                            </Box>
                        </Grid>
                        {['3', '6'].includes(tabValue) && (
                            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                                <Box sx={{pb: 2}}>
                                    <Controller render={({field: {value, onChange}}) => (
                                        <ApprovalStatus approvalStatus={value} setApprovalStatus={e => {
                                            saveFilter(e, 'approvalStatus')
                                        }}
                                                        dataList={bidComparsionApprovalStatuses}/>
                                    )} name="approvalStatus" control={control}/>

                                </Box>
                                <Box sx={{pb: 2}}>
                                    <Controller render={({field: {value, onChange}}) => (
                                        <Status dataList={bidComparsionStatuses} status={value} setStatus={e => {
                                            saveFilter(e, 'status')
                                        }}/>
                                    )} name="status" control={control}/>
                                </Box>
                                {/*<Box sx={{pb: 2}}>*/}
                                {/*    <Controller render={({field: {value, onChange}}) => (*/}
                                {/*        <OrderStatus dataList={bidComparsionOrderStatuses} value={value}*/}
                                {/*                     onChange={onChange}/>*/}
                                {/*    )} name="orderStatus" control={control}/>*/}
                                {/*</Box>*/}
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                <Grid
                    item
                    xs={xsGrid2}
                    sm={smGrid2}
                    md={mdGrid2}
                    lg={lgGrid2}
                    xl={xlGrid2}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Hidden smDown mdDown lgDown>
                        <Divider orientation="vertical" flexItem>
                            <IconButton onClick={handleClick}>
                                {open ? <ArrowCircleRightOutlinedIcon/> : <ArrowCircleLeftOutlinedIcon/>}
                            </IconButton>
                        </Divider>
                    </Hidden>
                    <Box>
                        <Collapse in={open}>{open ? <PaginationSystem/> : <Hidden/>}</Collapse>
                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={3} mt={1}>
                <Grid item xs={12}>
                    <Box sx={{width: '100%', typography: 'body1'}}>
                        <TabContext value={tabValue}>
                            <Box sx={{width: '100%', typography: 'body1'}}>
                                <TabContext value={tabValue}>
                                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                                            <Tab label="Waiting for Approvals" value="1"/>
                                            <Tab label="Drafts" value="2"/>
                                            <Tab label="All Comparison" value="3"/>
                                            <Tab label="Held" value="4"/>
                                            <Tab label="Rejected" value="5"/>
                                            <Tab label="My Charts" value="6"/>
                                            <Tab label="Not Released" value="7"/>
                                        </TabList>
                                    </Box>
                                    <TabPanel value="1">
                                        <WFA watch={watch} handleUpdateData={handleUpdateData}
                                             handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                    <TabPanel value="2">
                                        <Drafts watch={watch} handleUpdateData={handleUpdateData}
                                                handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                    <TabPanel value="3">
                                        <AllComparison watch={watch} handleUpdateData={handleUpdateData}
                                                       handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                    <TabPanel value="4">
                                        <Held watch={watch} handleUpdateData={handleUpdateData}
                                              handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                    <TabPanel value="5">
                                        <Rejected watch={watch} handleUpdateData={handleUpdateData}
                                                  handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                    <TabPanel value="6">
                                        <MyCharts watch={watch} handleUpdateData={handleUpdateData}
                                                  handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                    <TabPanel value="7">
                                        <NotReleased watch={watch} handleUpdateData={handleUpdateData}
                                                     handleRowAttachment={handleRowAttachment}/>
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </TabContext>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default BIDsComparison
